import { theme } from "themes/default/theme"

export const styles = {
  paper: {
    ...theme.mixins.modalContent,
    maxWidth: 800,
    backgroundColor: theme.palette.primary.main,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.common.white,
  },
  icon: { color: theme.palette.common.white },
  input: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    outline: "none",
    "& label.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "transparent",
      },
    },
    "& textarea": {
      color: theme.palette.common.black,
      fontSize: 25,
    },
  },
  button: {
    textTransform: "none",
    border: `3px solid ${theme.palette.common.white}`,
    padding: "5px 30px",
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: 20,
  },
}
